// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/exchanger.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Asset_Amount } from "./asset.ts";
import { AssetPair } from "./asset_pair.ts";
/**
 * @generated from protobuf message mlmbox.types.Exchanger
 */
export interface Exchanger {
    /**
     * @generated from protobuf field: uint32 source_asset_id = 1;
     */
    sourceAssetId: number;
    /**
     * @generated from protobuf field: uint32 target_asset_id = 2;
     */
    targetAssetId: number;
    /**
     * @generated from protobuf field: string rate = 3;
     */
    rate: string;
    /**
     * @generated from protobuf field: string limit_source_amount_min = 4;
     */
    limitSourceAmountMin: string;
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.List
 */
export interface Exchanger_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Exchanger items = 1;
     */
    items: Exchanger[];
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.Rate
 */
export interface Exchanger_Rate {
    /**
     * @generated from protobuf field: mlmbox.types.AssetPair asset_pair = 1;
     */
    assetPair?: AssetPair;
    /**
     * @generated from protobuf field: string rate_buy = 2;
     */
    rateBuy: string;
    /**
     * @generated from protobuf field: string rate_sell = 3;
     */
    rateSell: string;
    /**
     * @generated from protobuf field: uint32 modified_at = 4;
     */
    modifiedAt: number;
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.Rate.List
 */
export interface Exchanger_Rate_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Exchanger.Rate items = 1;
     */
    items: Exchanger_Rate[];
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.Id
 */
export interface Exchanger_Id {
    /**
     * @generated from protobuf field: uint32 source_asset_id = 1;
     */
    sourceAssetId: number;
    /**
     * @generated from protobuf field: uint32 target_asset_id = 2;
     */
    targetAssetId: number;
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.Request
 */
export interface Exchanger_Request {
    /**
     * @generated from protobuf field: uint32 source_asset_id = 1;
     */
    sourceAssetId: number;
    /**
     * @generated from protobuf field: uint32 target_asset_id = 2;
     */
    targetAssetId: number;
    /**
     * @generated from protobuf field: string source_amount = 3;
     */
    sourceAmount: string;
}
/**
 * @generated from protobuf message mlmbox.types.Exchanger.Response
 */
export interface Exchanger_Response {
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount source = 1;
     */
    source?: Asset_Amount;
    /**
     * @generated from protobuf field: mlmbox.types.Asset.Amount target = 2;
     */
    target?: Asset_Amount;
}
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger$Type extends MessageType<Exchanger> {
    constructor() {
        super("mlmbox.types.Exchanger", [
            { no: 1, name: "source_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "target_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "rate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "limit_source_amount_min", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Exchanger>): Exchanger {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceAssetId = 0;
        message.targetAssetId = 0;
        message.rate = "";
        message.limitSourceAmountMin = "";
        if (value !== undefined)
            reflectionMergePartial<Exchanger>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger): Exchanger {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 source_asset_id */ 1:
                    message.sourceAssetId = reader.uint32();
                    break;
                case /* uint32 target_asset_id */ 2:
                    message.targetAssetId = reader.uint32();
                    break;
                case /* string rate */ 3:
                    message.rate = reader.string();
                    break;
                case /* string limit_source_amount_min */ 4:
                    message.limitSourceAmountMin = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 source_asset_id = 1; */
        if (message.sourceAssetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.sourceAssetId);
        /* uint32 target_asset_id = 2; */
        if (message.targetAssetId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.targetAssetId);
        /* string rate = 3; */
        if (message.rate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rate);
        /* string limit_source_amount_min = 4; */
        if (message.limitSourceAmountMin !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.limitSourceAmountMin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger
 */
export const Exchanger = new Exchanger$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_List$Type extends MessageType<Exchanger_List> {
    constructor() {
        super("mlmbox.types.Exchanger.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Exchanger }
        ]);
    }
    create(value?: PartialMessage<Exchanger_List>): Exchanger_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Exchanger_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_List): Exchanger_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Exchanger items */ 1:
                    message.items.push(Exchanger.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Exchanger items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Exchanger.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.List
 */
export const Exchanger_List = new Exchanger_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_Rate$Type extends MessageType<Exchanger_Rate> {
    constructor() {
        super("mlmbox.types.Exchanger.Rate", [
            { no: 1, name: "asset_pair", kind: "message", T: () => AssetPair },
            { no: 2, name: "rate_buy", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rate_sell", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "modified_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Exchanger_Rate>): Exchanger_Rate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.rateBuy = "";
        message.rateSell = "";
        message.modifiedAt = 0;
        if (value !== undefined)
            reflectionMergePartial<Exchanger_Rate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_Rate): Exchanger_Rate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.AssetPair asset_pair */ 1:
                    message.assetPair = AssetPair.internalBinaryRead(reader, reader.uint32(), options, message.assetPair);
                    break;
                case /* string rate_buy */ 2:
                    message.rateBuy = reader.string();
                    break;
                case /* string rate_sell */ 3:
                    message.rateSell = reader.string();
                    break;
                case /* uint32 modified_at */ 4:
                    message.modifiedAt = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_Rate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.AssetPair asset_pair = 1; */
        if (message.assetPair)
            AssetPair.internalBinaryWrite(message.assetPair, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string rate_buy = 2; */
        if (message.rateBuy !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.rateBuy);
        /* string rate_sell = 3; */
        if (message.rateSell !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.rateSell);
        /* uint32 modified_at = 4; */
        if (message.modifiedAt !== 0)
            writer.tag(4, WireType.Varint).uint32(message.modifiedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.Rate
 */
export const Exchanger_Rate = new Exchanger_Rate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_Rate_List$Type extends MessageType<Exchanger_Rate_List> {
    constructor() {
        super("mlmbox.types.Exchanger.Rate.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Exchanger_Rate }
        ]);
    }
    create(value?: PartialMessage<Exchanger_Rate_List>): Exchanger_Rate_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Exchanger_Rate_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_Rate_List): Exchanger_Rate_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Exchanger.Rate items */ 1:
                    message.items.push(Exchanger_Rate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_Rate_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Exchanger.Rate items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Exchanger_Rate.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.Rate.List
 */
export const Exchanger_Rate_List = new Exchanger_Rate_List$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_Id$Type extends MessageType<Exchanger_Id> {
    constructor() {
        super("mlmbox.types.Exchanger.Id", [
            { no: 1, name: "source_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "target_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Exchanger_Id>): Exchanger_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceAssetId = 0;
        message.targetAssetId = 0;
        if (value !== undefined)
            reflectionMergePartial<Exchanger_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_Id): Exchanger_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 source_asset_id */ 1:
                    message.sourceAssetId = reader.uint32();
                    break;
                case /* uint32 target_asset_id */ 2:
                    message.targetAssetId = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 source_asset_id = 1; */
        if (message.sourceAssetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.sourceAssetId);
        /* uint32 target_asset_id = 2; */
        if (message.targetAssetId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.targetAssetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.Id
 */
export const Exchanger_Id = new Exchanger_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_Request$Type extends MessageType<Exchanger_Request> {
    constructor() {
        super("mlmbox.types.Exchanger.Request", [
            { no: 1, name: "source_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "target_asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "source_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Exchanger_Request>): Exchanger_Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sourceAssetId = 0;
        message.targetAssetId = 0;
        message.sourceAmount = "";
        if (value !== undefined)
            reflectionMergePartial<Exchanger_Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_Request): Exchanger_Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 source_asset_id */ 1:
                    message.sourceAssetId = reader.uint32();
                    break;
                case /* uint32 target_asset_id */ 2:
                    message.targetAssetId = reader.uint32();
                    break;
                case /* string source_amount */ 3:
                    message.sourceAmount = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 source_asset_id = 1; */
        if (message.sourceAssetId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.sourceAssetId);
        /* uint32 target_asset_id = 2; */
        if (message.targetAssetId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.targetAssetId);
        /* string source_amount = 3; */
        if (message.sourceAmount !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sourceAmount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.Request
 */
export const Exchanger_Request = new Exchanger_Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Exchanger_Response$Type extends MessageType<Exchanger_Response> {
    constructor() {
        super("mlmbox.types.Exchanger.Response", [
            { no: 1, name: "source", kind: "message", T: () => Asset_Amount },
            { no: 2, name: "target", kind: "message", T: () => Asset_Amount }
        ]);
    }
    create(value?: PartialMessage<Exchanger_Response>): Exchanger_Response {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Exchanger_Response>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Exchanger_Response): Exchanger_Response {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Asset.Amount source */ 1:
                    message.source = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* mlmbox.types.Asset.Amount target */ 2:
                    message.target = Asset_Amount.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Exchanger_Response, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Asset.Amount source = 1; */
        if (message.source)
            Asset_Amount.internalBinaryWrite(message.source, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* mlmbox.types.Asset.Amount target = 2; */
        if (message.target)
            Asset_Amount.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Exchanger.Response
 */
export const Exchanger_Response = new Exchanger_Response$Type();
